import { render, staticRenderFns } from "./square.vue?vue&type=template&id=2c7eea46&scoped=true&"
import script from "./square.vue?vue&type=script&lang=js&"
export * from "./square.vue?vue&type=script&lang=js&"
import style0 from "./square.vue?vue&type=style&index=0&id=2c7eea46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7eea46",
  null
  
)

export default component.exports